export default __webpack_public_path__ + "static/media/background.88892f54.svg";